import React, {useContext} from 'react';

import {Button, SelectDropdown} from '../../common';
import {StaticData} from '../../context/staticData';

export default function ProductOverviewHeader({sorting, totalResults, updateSorting, filterOpen, setFilterOpen, isLoading}) {
    const {
        customOptions: {vehicleListState},
    } = useContext(StaticData);

    const getTitle = (totalResults, vehiclesState, isLoading) => {
        if (totalResults === 0) {
            return isLoading ? `Auto's worden geladen...` : `Geen auto's gevonden`;
        } else {
            switch (vehiclesState) {
                case "new":
                    return `Onze ${totalResults} nieuwe auto's`;
                case "occasion":
                    return `Onze ${totalResults} occasions`;
                default:
                    return `Onze ${totalResults} auto's`;
            }
        }
    }

    return (
        <div className="row gutters-2 gutters-lg-3 align-items-center justify-content-between">
            <div className="col-12 col-lg-auto">
                <h1 className="h1 font-weight-light">
                    {getTitle(totalResults, vehicleListState, isLoading)}
                </h1>
            </div>
            <div className="col-12 col-lg-3">
                <SelectDropdown
                    id="filter-sorting"
                    className="custom-select"
                    name="sort"
                    emptyValueLabel="Sorteren"
                    options={sorting}
                    onChange={(options) => {
                        updateSorting(options);
                    }}
                />
            </div>
            <div className="col-12 col-lg-3 d-lg-none">
                <Button
                    classes="btn-block"
                    linkTitle="Filteren"
                    onClick={() => setFilterOpen(!filterOpen)}
                />
            </div>
        </div>
    );
}
